function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { warn } from '@ember/debug';
import Component from '@ember/component';
import { componentNodes } from '../-private/ember-internals';
/*
   This component has one job: tracking which DOM elements correspond
   with which list elements.
*/

export default class extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _defineProperty(this, "isEmberAnimatedListElement", true);
    _defineProperty(this, "child", void 0);
    _defineProperty(this, "elementToChild", void 0);
  }
  didRender() {
    let mapping = this.get('elementToChild');
    let child = this.get('child');
    this._forEachElement(elt => {
      mapping.set(elt, child);
    });
  }
  _forEachElement(fn) {
    let {
      firstNode,
      lastNode
    } = componentNodes(this);
    let node = firstNode;
    while (node) {
      if (node.nodeType === Node.ELEMENT_NODE) {
        fn(node);
      } else if (!/^\s*$/.test(node.textContent)) {
        warn('Found bare text content inside an animator', false, {
          id: 'ember-animated-bare-text'
        });
      }
      if (node === lastNode) {
        break;
      }
      node = node.nextSibling;
    }
  }
}